export const HIDDEN_WELL_KNOWN_FIELD_KEYS = [
  'contract_record_unique_id_original',
] as const;

export const WELL_KNOWN_FIELD_ORDER = [
  'contract_title',
  'contract_description',
  'contract_type',
  'company',
  'supplier',
  'start_date',
  'end_date',
  'final_spend',
  'currency',
] as const;
